import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { HouseAction } from '@stores/house/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import Toast from '@components/Toast';
import { getUrlParams } from '@utils/getUrlParams';
import { px2rem } from '@utils/px2rem'

interface HouseLetterH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    house?: HouseAction;
}
interface HouseLetterH5State {
  loading: boolean;
  error: any
  pageLoaded: any
  showGoLikeStatus: any
  routerSource?: any
  readyStatus: any
  downloadAppStatus: boolean; // 是否显示下载入口，用来记录下载入口的初始化状态，返回到其他页面后恢复下载入口的显示状态
  headerShowStatus: boolean;  // 是否显示header，用来记录header的初始化状态，返回到其他页面后恢复header的显示状态
}
@inject('app', 'site', 'user', 'house')
@observer
class HouseLetterH5Page extends BasePage<HouseLetterH5PageProps, HouseLetterH5State> {
  state = {
    loading: false,
    error: null,
    pageLoaded: false,
    showGoLikeStatus: false,  // 是否显示去点赞新家入口
    routerSource: '',   // 路由上的source参数
    readyStatus: true, // 数据是否已加载完成
    downloadAppStatus: false, // 是否显示下载入口
    headerShowStatus: false,  // 是否显示header
  }
  
  // 添加 ref 来引用 letterContent 元素
  private letterInnerRef = React.createRef<HTMLDivElement>();
  private scrollTimeout: NodeJS.Timeout | null = null;
  
  componentDidMount() {
    
    super.componentDidMount();
    
    // 初始化窗口尺寸和滚动位置
    this.updateScrollPosition();
    
    // 添加事件监听 - 这里先不立即绑定，等待ref获取
    this.bindScrollEvent();
    
    const { site, house } = this.props;
    if (site) {
      // console.log(site.getAppDownloadShowStatus(), '入口是否显示', site.getShowHeader(), 'header是否显示')
        // setTimeout(() => {
            this.setState({
                downloadAppStatus: site.getAppDownloadShowStatus(),
                headerShowStatus: site.getShowHeader(),

            }, () => {
                site.setShowHeader(false);
                site.setAppDownloadShowStatus(false);
            })
            
        // }, 100);
    }
    const routerParams = new URLSearchParams(this.props.location.search);
    const source: any = routerParams?.get('source') || '';

    this.setState({
        routerSource: source
    })
    // const allParams = getUrlParams();
    // console.log(allParams, '参数');
    // if(house) {
    //   house.getHouseCert().then(res => {
    //       console.log('获取房产证信息', res.data?.is_issued);
    //       if(res.code == 0) {
    //           if(res.data?.is_issued) {   // 如果已领取，直接显示房产证信息
    //             const queryParams = source === 'app' ? '?rotate=1&source=app' : '?rotate=1';
    //             this.props.history.push(`/houseCard${queryParams}`);
    //           } else {  // 如果未领取，走领取流程
    //              this.setState({
    //                 readyStatus: true
    //              })
    //           }
              
             
    //       } else {
    //         this.setState({
    //           readyStatus: true
    //         })
    //       }
    //   })
    // }
  }

  
  // 绑定滚动事件
  bindScrollEvent = () => {
    // 使用 setTimeout 确保组件已挂载，DOM 已渲染
    setTimeout(() => {
      const letterContent = this.letterInnerRef.current;
      if (letterContent) {
        // 移除之前可能的事件监听
        letterContent.removeEventListener('scroll', this.handleScroll);
        // 添加新的滚动事件监听
        letterContent.addEventListener('scroll', this.handleScroll);
        // console.log('已绑定letterContent滚动事件');
      } else {
        // console.warn('letterContent元素未找到，尝试重新绑定...');
        // 如果没找到，稍后再试
        setTimeout(this.bindScrollEvent, 100);
      }
    }, 100);
  }
  
  componentWillUnmount() {
    // 移除事件监听
    this.removeScrollEvent();
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    let { downloadAppStatus, headerShowStatus} = this.state;
    console.log('组件卸载', downloadAppStatus, headerShowStatus);
    const { site } = this.props;
    if(site) {
      site.setShowHeader(headerShowStatus);
      site.setAppDownloadShowStatus(downloadAppStatus);
    }
    
  }
  
  // 移除滚动事件
  removeScrollEvent = () => {
    const letterContent = this.letterInnerRef.current;
    if (letterContent) {
      letterContent.removeEventListener('scroll', this.handleScroll);
    }
  }
  
  // 更新滚动位置
  updateScrollPosition = () => {
    const letterContent = this.letterInnerRef.current;
    if (!letterContent) return;
    
    const scrollTop = letterContent.scrollTop;
    const scrollHeight = letterContent.scrollHeight;
    const clientHeight = letterContent.clientHeight;
    
    // 计算滚动百分比
    const scrollPercent = scrollTop / (scrollHeight - clientHeight);
    
    // 检查滚动距离是否超过100px或滚动百分比超过一定值
    if (scrollTop > 100 || scrollPercent > 0.1) {
      this.setState({
        showGoLikeStatus: true
      });
    } else {
      // this.setState({
      //   showGoLikeStatus: false
      // });
    }
  }
  
  // 防抖处理滚动事件
  handleScroll = () => {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.updateScrollPosition();
    }, 16); // 约60fps
  }
  
  render() {
    let { showGoLikeStatus, routerSource, readyStatus } = this.state;
    console.log(getUrlParams(), '路由参数', routerSource)
    return (<>
      {readyStatus && <div className={styles.houseWrap}>
        <div className={styles.houseHeader} style={{paddingTop: routerSource == 'app' ? px2rem(80) : px2rem(20)}}>
          <img src={`${BASE_IMG_URL}/house/back.png`} alt="" className={styles.close}  onClick={() => {
            if(getUrlParams().source == 'app') {  // 如果是app打开，调用app给的js方法
              // js_normal.onBackClick()
            } else {  // 回到首页
              window.ensureBack(
                () => {
                //   console.log('返回完成');
                }
              );
              let { site } = this.props;
              if (site) {
                  site.setShowHeader(true);
              }
            }
          }} />
        </div>
        <div className={styles.logoBox} style={{paddingBottom: getUrlParams().source == 'app' ? px2rem(48) : '', paddingTop: getUrlParams().source == 'app' ? px2rem(48) : ''}}>
          <img src={`${BASE_IMG_URL}/common/h5_logo2.png`} alt="" className={styles.logo} onClick={() => {
            this.props.history.push(`/`)
          }} />
          <img src={`${BASE_IMG_URL}/house/img4.png`} alt="" className={styles.tip} />
        </div>
        <img src={`${BASE_IMG_URL}/house/img7.png`} alt="" className={styles.letterTitle}  style={{marginBottom: getUrlParams().source == 'app' ? px2rem(48) : ''}}/>
        <div className={styles.letterOutBox}>
          <div className={styles.letterInnerBox} ref={this.letterInnerRef}>
            {/* 添加 ref 到 letterContent 元素 */}
            <div 
              className={styles.letterContent}>
              <div className={styles.title}>亲爱的<span>V粉小伙伴</span>：</div>
              <div>&nbsp;</div>
              <div>2026伊始，我们有一个好消息告诉大家：<span>无数V粉日夜期盼的"新家"终于来了</span></div>
              <div style={{textIndent: 0}}><span>——vivo社区App上线了～</span></div>
              <img src={`${BASE_IMG_URL}/house/emo.gif`} alt="" className={styles.emo} />
              <div>在过去，我们虽有方寸安身之地，<span>但总感觉少了些什么，一个只有V粉的地方，一个可以供大家玩耍的一方天地，一个可以让大家分享生活日常的家。</span>今天，它终于来了，我们有了属于自己的家，每一块砖、每一片瓦，都刻着"V粉"的名字，<span>即将承载着我们共同的回忆与对未来的期盼。</span></div>
              <div>&nbsp;</div>
              <div>目前，房子已初步完成简装，<span>通了水电，亮了灯光，剩下的就交给即将入住的你们。我们希望，这个房子与所有V粉一同完成装修，让住进来的V粉更方便，更舒适，更安心。</span>我们深知，房子之所以成为家，是因为住在里面的人，<span>无论在哪里，有了你们这个家才完整。</span>这个家，现在缺你的笑声、你的故事、你的梦想，所以，我们现诚挚邀请每一位V粉：<span>来这里安家。</span></div>
              <div>&nbsp;</div>
              <div>你可以来<span>聊聊vivo手机使用技巧/分享使用心得</span>，可以<span>分享刚拍下的夕阳/路上遇见的美好</span>，也可以来<span>说说生活里的小事</span>，更或是<span>遇见兴趣相投的人</span>。无论你是谁，这里都有属于你的位置。</div>
              <div>&nbsp;</div>
              <div>这个家，属于我们每个V粉。</div>
              <div>它会是我们倾听彼此的树洞，会是灵感迸发的角落，也会是和vivo一起走过的共同回忆。</div>
              <div>&nbsp;</div>
              <div>从"租房"到"买房"，<span>是vivo和V粉共同完成的"约定"。</span></div>
              <div>V粉们从来不只是用户，而是跟vivo一路同行的伙伴，是这个家真正的主人。</div>
              <div>2026年，让我们把这里，共建成属于你我的理想家园。</div>
              <div>门已敞开，钥匙已交付到你手中。欢迎回家！<span>欢迎常回家看看！</span></div>
              <div>&nbsp;</div>
              {/* <div>&nbsp;</div> */}
              <div>vivo社区App业主委员会</div>
              <div>2026年1月5日</div>
              <div>&nbsp;</div>
              {/* <div>&nbsp;</div> */}
              {/* <img src={`${BASE_IMG_URL}/house/img5.png`} alt="" className={styles.goLikeImg} onClick={() => window.globalEnsureLogin(() => {
                  // if (showGoLikeStatus) {
                    if(routerSource == 'app') {
                      this.props.history.push(`/houseLike?source=app`)
                    } else {
                      this.props.history.push(`/houseLike`)
                    }
                    
                  // }
              })}/> */}
              {/* <div>&nbsp;</div> */}
              {/* <div>&nbsp;</div> */}
            </div>
          </div>
          <div className={styles.letterBottomBox}>
            {/* 过渡容器：根据 showGoLikeStatus 切换样式并触发动画 */}
            <div
              className={`${styles.transitionBox} ${showGoLikeStatus ? styles.expanded : ''}`}
              onClick={() => {
                  if (showGoLikeStatus) {
                    if(routerSource == 'app') {
                      this.props.history.push(`/houseLike?source=app`)
                    } else {
                      this.props.history.push(`/houseLike`)
                    }
                  }
              }}
            >
              <div className={styles.content}>
                <img src={`${BASE_IMG_URL}/house/icon7.png`} alt="" className={styles.icon1} />
                <span>去为V粉搬新家点赞</span>
                <img src={`${BASE_IMG_URL}/house/icon8.png`} alt="" className={styles.icon2} />
              </div>
            </div>
          </div>
        </div>
      </div>}
      </>
    )
  }
}

export default withRouter(HouseLetterH5Page);